<!-- 获取广告曝光度统计信息 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "parkCode": "2KKN885S",
                "start": "20190618000000",
                "end": "20190818235959",
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "adPvList": [
                        {
                            "adId": 2,
                            "adName": "测试",
                            "adType": 1,
                            "createBy": "xxx",
                            "createTime": "20190717154610",
                            "id": 200005,
                            "parkCode": "2KKN885S",
                            "parkName": "昌俊停车场",
                            "periodDesc": "15:00~16:00",
                            "periodEnd": "20190717160000",
                            "periodStart": "20190717150000",
                            "pvTotal": 7
                        }
                    ],
                    "currCount": 1,
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,获取广告曝光度统计信息",
                t_url: this.commonUrls.test+"getAdPvStatistics",
                p_url: this.commonUrls.prod+"getAdPvStatistics",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'adId', info2: '否', info3: 'Integer', info4: '广告ID，adId与时间段至少填一个' },
                        { info1: 'parkCode', info2: '否', info3: 'String', info4: '停车场编码' },
                        { info1: 'adLocation', info2: '否', info3: 'String', info4: '广告位置' },
                        { info1: 'start', info2: '否', info3: 'String', info4: '框选广告开始时间，时间起始时间，adId与时间段至少填一个，yyyyMMddHHmmss' },
                        { info1: 'end', info2: '否', info3: 'String', info4: '框选广告开始时间，时间段结束时间，adId与时间段至少填一个，yyyyMMddHHmmss' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'adPvList', info2: '是', info3: 'String', info4: '用户信息列表' },
                        ]
                },{
                    titleName: 'adPvList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: 'ID' },
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编码' },
                        { info1: 'parkName', info2: '是', info3: 'String', info4: '停车场名称' },
                        { info1: 'adId', info2: '是', info3: 'Long', info4: '广告ID' },
                        { info1: 'adType', info2: '是', info3: 'Integer', info4: '广告类型 0：ad_config表 1：APP_AD_CONFIG表,即0，ad_id对应ad_config.id;1,ad_id对应app_ad_config.ad_id' },
                        { info1: 'adName', info2: '是', info3: 'String', info4: '广告名称' },
                        { info1: 'periodStart', info2: '是', info3: 'String', info4: '广告开始时间，yyyyMMddHHmmss' },
                        { info1: 'periodEnd', info2: '是', info3: 'String', info4: '广告结束时间，yyyyMMddHHmmss' },
                        { info1: 'periodDesc', info2: '是', info3: 'String', info4: '时间段描述' },
                        { info1: 'pvTotal', info2: '是', info3: 'Long', info4: '曝光数' },
                        { info1: 'createTime', info2: '是', info3: 'String', info4: '创建时间，yyyyMMddHHmmss' },
                        { info1: 'createBy', info2: '是', info3: 'String', info4: '创建人' },
                        { info1: 'updateTime', info2: '是', info3: 'String', info4: '更新时间，yyyyMMddHHmmss' },
                        { info1: 'updateBy', info2: '是', info3: 'String', info4: '更新人' },
                        { info1: 'locationList', info2: '否', info3: 'JSONArray', info4: '曝光位置' },
                        ]
                },{
                    titleName: 'locationList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'pvTotal', info2: '是', info3: 'Long', info4: '曝光数' },
                        { info1: 'adLocation', info2: '是', info3: 'String', info4: '曝光位置' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ad/getAdPvStatistics.vue